import type { LocationInfoData } from 'tripPlanner/components/Chat/Message'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// A suggestion has no entity id, so the place searched carries its identity, and leads so
// that shortening reaches the title first. Equal-titled suggestions for different places
// are different actions; the same suggestion twice stays one repeat.
export function buildLocationSuggestionOpenedActivityEntry({ title, placeSearch }: Pick<LocationInfoData, 'title' | 'placeSearch'>): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'location_suggestion_opened',
    label: 'Opened suggested location',
    displayText: boundActivityDisplayText(`Opened suggestion for ${placeSearch}: "${title}"`),
    sourcePath: 'trip_planner.chat.suggestion_card',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
